/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CommonResponseDto,
  CreateEmailCodeParams,
  GetVerifyAccountEmailParams,
  GetVerifyAccountPlatformParams,
  HTTPValidationError,
  RefreshToken,
  ResetPasswordRequestDto,
  SigninRequestDto,
  TokenResponse,
  TossAuthorizationRequest,
  VerifyEmailCodeParams
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 로그인API
 * @summary Signin
 */
export const signIn = (
    signinRequestDto: SigninRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<TokenResponse>(
      {url: `/auth/signin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signinRequestDto
    },
      options);
    }
  


export const getSignInMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SigninRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SigninRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signIn>>, {data: SigninRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  signIn(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignInMutationResult = NonNullable<Awaited<ReturnType<typeof signIn>>>
    export type SignInMutationBody = SigninRequestDto
    export type SignInMutationError = HTTPValidationError

    /**
 * @summary Signin
 */
export const useSignIn = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SigninRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof signIn>>,
        TError,
        {data: SigninRequestDto},
        TContext
      > => {

      const mutationOptions = getSignInMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 어카운트의이메일중복을체크하는API
 * @summary GetVerifyAccountEmail
 */
export const getVerifyAccountEmail = (
    params: GetVerifyAccountEmailParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<CommonResponseDto>(
      {url: `/auth/verify-email`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetVerifyAccountEmailQueryKey = (params: GetVerifyAccountEmailParams,) => {
    return [`/auth/verify-email`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVerifyAccountEmailQueryOptions = <TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(params: GetVerifyAccountEmailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifyAccountEmailQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifyAccountEmail>>> = ({ signal }) => getVerifyAccountEmail(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVerifyAccountEmailQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifyAccountEmail>>>
export type GetVerifyAccountEmailQueryError = HTTPValidationError


export function useGetVerifyAccountEmail<TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(
 params: GetVerifyAccountEmailParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifyAccountEmail>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetVerifyAccountEmail<TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(
 params: GetVerifyAccountEmailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifyAccountEmail>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetVerifyAccountEmail<TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(
 params: GetVerifyAccountEmailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetVerifyAccountEmail
 */

export function useGetVerifyAccountEmail<TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(
 params: GetVerifyAccountEmailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVerifyAccountEmailQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetVerifyAccountEmailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(params: GetVerifyAccountEmailParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifyAccountEmailQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifyAccountEmail>>> = ({ signal }) => getVerifyAccountEmail(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVerifyAccountEmailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifyAccountEmail>>>
export type GetVerifyAccountEmailSuspenseQueryError = HTTPValidationError


export function useGetVerifyAccountEmailSuspense<TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(
 params: GetVerifyAccountEmailParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetVerifyAccountEmailSuspense<TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(
 params: GetVerifyAccountEmailParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetVerifyAccountEmailSuspense<TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(
 params: GetVerifyAccountEmailParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetVerifyAccountEmail
 */

export function useGetVerifyAccountEmailSuspense<TData = Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError = HTTPValidationError>(
 params: GetVerifyAccountEmailParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountEmail>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVerifyAccountEmailSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 어카운트의쇼핑몰중복을체크하는API
 * @summary GetVerifyPlatform
 */
export const getVerifyAccountPlatform = (
    params: GetVerifyAccountPlatformParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<CommonResponseDto>(
      {url: `/auth/verify-platform`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetVerifyAccountPlatformQueryKey = (params: GetVerifyAccountPlatformParams,) => {
    return [`/auth/verify-platform`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVerifyAccountPlatformQueryOptions = <TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(params: GetVerifyAccountPlatformParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifyAccountPlatformQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifyAccountPlatform>>> = ({ signal }) => getVerifyAccountPlatform(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVerifyAccountPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifyAccountPlatform>>>
export type GetVerifyAccountPlatformQueryError = HTTPValidationError


export function useGetVerifyAccountPlatform<TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(
 params: GetVerifyAccountPlatformParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifyAccountPlatform>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetVerifyAccountPlatform<TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(
 params: GetVerifyAccountPlatformParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifyAccountPlatform>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetVerifyAccountPlatform<TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(
 params: GetVerifyAccountPlatformParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetVerifyPlatform
 */

export function useGetVerifyAccountPlatform<TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(
 params: GetVerifyAccountPlatformParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVerifyAccountPlatformQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetVerifyAccountPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(params: GetVerifyAccountPlatformParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifyAccountPlatformQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifyAccountPlatform>>> = ({ signal }) => getVerifyAccountPlatform(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVerifyAccountPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifyAccountPlatform>>>
export type GetVerifyAccountPlatformSuspenseQueryError = HTTPValidationError


export function useGetVerifyAccountPlatformSuspense<TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(
 params: GetVerifyAccountPlatformParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetVerifyAccountPlatformSuspense<TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(
 params: GetVerifyAccountPlatformParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetVerifyAccountPlatformSuspense<TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(
 params: GetVerifyAccountPlatformParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetVerifyPlatform
 */

export function useGetVerifyAccountPlatformSuspense<TData = Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError = HTTPValidationError>(
 params: GetVerifyAccountPlatformParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVerifyAccountPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVerifyAccountPlatformSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 이메일인증코드발송API
 * @summary CreateEmailCode
 */
export const createEmailCode = (
    params: CreateEmailCodeParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<CommonResponseDto>(
      {url: `/auth/create-code`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreateEmailCodeQueryKey = (params: CreateEmailCodeParams,) => {
    return [`/auth/create-code`, ...(params ? [params]: [])] as const;
    }

    
export const getCreateEmailCodeQueryOptions = <TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(params: CreateEmailCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateEmailCodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof createEmailCode>>> = ({ signal }) => createEmailCode(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData> & { queryKey: QueryKey }
}

export type CreateEmailCodeQueryResult = NonNullable<Awaited<ReturnType<typeof createEmailCode>>>
export type CreateEmailCodeQueryError = HTTPValidationError


export function useCreateEmailCode<TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(
 params: CreateEmailCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createEmailCode>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCreateEmailCode<TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(
 params: CreateEmailCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createEmailCode>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCreateEmailCode<TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(
 params: CreateEmailCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary CreateEmailCode
 */

export function useCreateEmailCode<TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(
 params: CreateEmailCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCreateEmailCodeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreateEmailCodeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(params: CreateEmailCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateEmailCodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof createEmailCode>>> = ({ signal }) => createEmailCode(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData> & { queryKey: QueryKey }
}

export type CreateEmailCodeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof createEmailCode>>>
export type CreateEmailCodeSuspenseQueryError = HTTPValidationError


export function useCreateEmailCodeSuspense<TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(
 params: CreateEmailCodeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCreateEmailCodeSuspense<TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(
 params: CreateEmailCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCreateEmailCodeSuspense<TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(
 params: CreateEmailCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary CreateEmailCode
 */

export function useCreateEmailCodeSuspense<TData = Awaited<ReturnType<typeof createEmailCode>>, TError = HTTPValidationError>(
 params: CreateEmailCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof createEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCreateEmailCodeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 이메일인증코드인증API
 * @summary VerifyEmailCode
 */
export const verifyEmailCode = (
    params: VerifyEmailCodeParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<CommonResponseDto>(
      {url: `/auth/verify-code`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getVerifyEmailCodeQueryKey = (params: VerifyEmailCodeParams,) => {
    return [`/auth/verify-code`, ...(params ? [params]: [])] as const;
    }

    
export const getVerifyEmailCodeQueryOptions = <TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(params: VerifyEmailCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerifyEmailCodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyEmailCode>>> = ({ signal }) => verifyEmailCode(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData> & { queryKey: QueryKey }
}

export type VerifyEmailCodeQueryResult = NonNullable<Awaited<ReturnType<typeof verifyEmailCode>>>
export type VerifyEmailCodeQueryError = HTTPValidationError


export function useVerifyEmailCode<TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(
 params: VerifyEmailCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyEmailCode>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useVerifyEmailCode<TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(
 params: VerifyEmailCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyEmailCode>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useVerifyEmailCode<TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(
 params: VerifyEmailCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary VerifyEmailCode
 */

export function useVerifyEmailCode<TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(
 params: VerifyEmailCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getVerifyEmailCodeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getVerifyEmailCodeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(params: VerifyEmailCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerifyEmailCodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyEmailCode>>> = ({ signal }) => verifyEmailCode(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData> & { queryKey: QueryKey }
}

export type VerifyEmailCodeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof verifyEmailCode>>>
export type VerifyEmailCodeSuspenseQueryError = HTTPValidationError


export function useVerifyEmailCodeSuspense<TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(
 params: VerifyEmailCodeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useVerifyEmailCodeSuspense<TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(
 params: VerifyEmailCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useVerifyEmailCodeSuspense<TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(
 params: VerifyEmailCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary VerifyEmailCode
 */

export function useVerifyEmailCodeSuspense<TData = Awaited<ReturnType<typeof verifyEmailCode>>, TError = HTTPValidationError>(
 params: VerifyEmailCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyEmailCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getVerifyEmailCodeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 유저비활성화인증API
 * @summary VerifyBlockCode
 */
export const verifyBlockCode = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<CommonResponseDto>(
      {url: `/auth/verify-block-code`, method: 'GET', signal
    },
      options);
    }
  

export const getVerifyBlockCodeQueryKey = () => {
    return [`/auth/verify-block-code`] as const;
    }

    
export const getVerifyBlockCodeQueryOptions = <TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerifyBlockCodeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyBlockCode>>> = ({ signal }) => verifyBlockCode(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData> & { queryKey: QueryKey }
}

export type VerifyBlockCodeQueryResult = NonNullable<Awaited<ReturnType<typeof verifyBlockCode>>>
export type VerifyBlockCodeQueryError = HTTPValidationError


export function useVerifyBlockCode<TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyBlockCode>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useVerifyBlockCode<TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyBlockCode>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useVerifyBlockCode<TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary VerifyBlockCode
 */

export function useVerifyBlockCode<TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getVerifyBlockCodeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getVerifyBlockCodeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVerifyBlockCodeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyBlockCode>>> = ({ signal }) => verifyBlockCode(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData> & { queryKey: QueryKey }
}

export type VerifyBlockCodeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof verifyBlockCode>>>
export type VerifyBlockCodeSuspenseQueryError = HTTPValidationError


export function useVerifyBlockCodeSuspense<TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useVerifyBlockCodeSuspense<TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useVerifyBlockCodeSuspense<TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary VerifyBlockCode
 */

export function useVerifyBlockCodeSuspense<TData = Awaited<ReturnType<typeof verifyBlockCode>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof verifyBlockCode>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getVerifyBlockCodeSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카드TOSS인증API
 * @summary VerifyCard
 */
export const verifyCard = (
    tossAuthorizationRequest: TossAuthorizationRequest,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/auth/verify-card`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tossAuthorizationRequest
    },
      options);
    }
  


export const getVerifyCardMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCard>>, TError,{data: TossAuthorizationRequest}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyCard>>, TError,{data: TossAuthorizationRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCard>>, {data: TossAuthorizationRequest}> = (props) => {
          const {data} = props ?? {};

          return  verifyCard(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyCardMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCard>>>
    export type VerifyCardMutationBody = TossAuthorizationRequest
    export type VerifyCardMutationError = HTTPValidationError

    /**
 * @summary VerifyCard
 */
export const useVerifyCard = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCard>>, TError,{data: TossAuthorizationRequest}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof verifyCard>>,
        TError,
        {data: TossAuthorizationRequest},
        TContext
      > => {

      const mutationOptions = getVerifyCardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 비밀번호재설정
 * @summary ResetPassword
 */
export const resetPassword = (
    resetPasswordRequestDto: ResetPasswordRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<TokenResponse>(
      {url: `/auth/reset-password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordRequestDto
    },
      options);
    }
  


export const getResetPasswordMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordRequestDto
    export type ResetPasswordMutationError = HTTPValidationError

    /**
 * @summary ResetPassword
 */
export const useResetPassword = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordRequestDto},
        TContext
      > => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 토큰리프레시API
 * @summary TokenRefresh
 */
export const tokenRefresh = (
    refreshToken: RefreshToken,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<TokenResponse>(
      {url: `/auth/token_refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshToken
    },
      options);
    }
  


export const getTokenRefreshMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenRefresh>>, TError,{data: RefreshToken}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof tokenRefresh>>, TError,{data: RefreshToken}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tokenRefresh>>, {data: RefreshToken}> = (props) => {
          const {data} = props ?? {};

          return  tokenRefresh(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TokenRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof tokenRefresh>>>
    export type TokenRefreshMutationBody = RefreshToken
    export type TokenRefreshMutationError = HTTPValidationError

    /**
 * @summary TokenRefresh
 */
export const useTokenRefresh = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenRefresh>>, TError,{data: RefreshToken}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof tokenRefresh>>,
        TError,
        {data: RefreshToken},
        TContext
      > => {

      const mutationOptions = getTokenRefreshMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 카페24자동로그인API
 * @summary SigninWithPlatform
 */
export const signinWithPlatform = (
    platformId: string,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<TokenResponse>(
      {url: `/auth/signin/${platformId}`, method: 'GET', signal
    },
      options);
    }
  

export const getSigninWithPlatformQueryKey = (platformId: string,) => {
    return [`/auth/signin/${platformId}`] as const;
    }

    
export const getSigninWithPlatformQueryOptions = <TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSigninWithPlatformQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof signinWithPlatform>>> = ({ signal }) => signinWithPlatform(platformId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type SigninWithPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof signinWithPlatform>>>
export type SigninWithPlatformQueryError = HTTPValidationError


export function useSigninWithPlatform<TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof signinWithPlatform>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useSigninWithPlatform<TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof signinWithPlatform>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useSigninWithPlatform<TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary SigninWithPlatform
 */

export function useSigninWithPlatform<TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSigninWithPlatformQueryOptions(platformId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSigninWithPlatformSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSigninWithPlatformQueryKey(platformId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof signinWithPlatform>>> = ({ signal }) => signinWithPlatform(platformId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(platformId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData> & { queryKey: QueryKey }
}

export type SigninWithPlatformSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof signinWithPlatform>>>
export type SigninWithPlatformSuspenseQueryError = HTTPValidationError


export function useSigninWithPlatformSuspense<TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useSigninWithPlatformSuspense<TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useSigninWithPlatformSuspense<TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary SigninWithPlatform
 */

export function useSigninWithPlatformSuspense<TData = Awaited<ReturnType<typeof signinWithPlatform>>, TError = HTTPValidationError>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof signinWithPlatform>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSigninWithPlatformSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



